import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { MessageSquarePlus } from "lucide-react";

export function NewMessageDialog({ isAdmin, customers, onSent }) {
  const [open, setOpen] = useState(false);
  const [recipient, setRecipient] = useState("");
  const [first, setFirst] = useState("");
  const startNew = async () => {
    if (!first.trim()) { toast.error("Message body required"); return; }
    try {
      const payload = { body: first };
      if (isAdmin || customers.length > 1) payload.recipient_id = recipient || undefined;
      const { data } = await api.post("/messages", payload);
      toast.success("Message sent");
      setOpen(false); setFirst(""); setRecipient("");
      onSent(data.thread_id);
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-blue-700 hover:bg-blue-800" data-testid="new-message-button"><MessageSquarePlus className="h-4 w-4 mr-2" />New Message</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>{isAdmin ? "Message Customer" : "New message"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {(isAdmin || customers.length > 1) && (
            <div>
              <Label>Recipient</Label>
              <Select value={recipient} onValueChange={setRecipient}>
                <SelectTrigger data-testid="new-message-recipient-select"><SelectValue placeholder="Select recipient" /></SelectTrigger>
                <SelectContent>
                  {customers.map((c) => (<SelectItem key={c.id} value={c.id}>{c.role === "admin" ? `${c.name} · Safer Highways` : c.role === "terminal_manager" ? `${c.name} · ${c.terminal_name || "Terminal manager"} (${c.company})` : `${c.name} · ${c.company}`}</SelectItem>))}
                </SelectContent>
              </Select>
            </div>
          )}
          <div><Label>Message</Label><Input value={first} onChange={(e) => setFirst(e.target.value)} data-testid="new-message-body-input" /></div>
          <DialogFooter><Button className="bg-blue-700 hover:bg-blue-800" onClick={startNew} data-testid="new-message-send-button">Send</Button></DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
